// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-0805134e]{display:none}.youtube-player[data-v-0805134e]{aspect-ratio:16/9;height:auto;margin:.4rem;max-width:100%;position:relative;width:100%}.youtube-player .thumbnail[data-v-0805134e]{cursor:pointer}.youtube-player iframe[data-v-0805134e]{background:transparent;height:100%;left:0;position:absolute;top:0;width:100%;z-index:100}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
